import {Button, Typography, useMediaQuery, useTheme} from '@mui/material';
import {BackgroundColorInfo, IBackground} from '../../../../api/models';
import {Color} from '../../../../common/theme';
import {ColorPicker, useColor} from 'react-color-palette';
import 'react-color-palette/css';
import {apiClient} from '../../../../foundation/apiClient';
import {useEventBatching} from '../../../../api/events';

interface BackgroundColorPickerProps {
    isBackgroundPresent: boolean;
    sectionId: string;
    backgroundInfo?: IBackground;
}

export const BackgroundColorPicker = (props: BackgroundColorPickerProps) => {
    const backgroundColor = props.backgroundInfo
        ? (props.backgroundInfo as BackgroundColorInfo).backgroundColor
        : Color.SEA_GREEN;
    const [color, updateColor] = useColor(backgroundColor);
    const {trackEvent} = useEventBatching();
    const theme = useTheme();

    const updateBackgroundColor = async () => {
        const formData = new FormData();
        formData.append('color', color.hex);
        formData.append('sectionId', props.sectionId);
        formData.append('backgroundType', 'BackgroundColor');
        apiClient
            .post('media/background/update', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then(() => {
                trackEvent({
                    eventName: 'SECTION_BACKGROUND_COLOR_UPDATE_SUCCESS',
                    props: {
                        color: color.hex,
                        sectionId: props.sectionId,
                    },
                });
            })
            .catch((err) => {
                trackEvent({
                    eventName: 'SECTION_BACKGROUND_COLOR_UPDATE_FAILED',
                    props: {
                        color: color.hex,
                        sectionId: props.sectionId,
                        error: err.toString(),
                    },
                });
            });
    };

    const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const buttonStyles = isMobileScreen
        ? {
              padding: '10px 20px',
              fontSize: '14px',
              borderRadius: '8px',
              width: '100%',
              backgroundColor: '#90909d',
              color: 'white',
              marginTop: '12px',
              overflow: 'hidden',
              textAlign: 'center',
              whitespace: 'normal',
              lineHeight: '1.2',
          }
        : {};

    return (
        <>
            <br />
            <ColorPicker color={color} onChange={updateColor} />

            <div>
                <Button sx={buttonStyles} onClick={updateBackgroundColor}>
                    <Typography
                        sx={{
                            marginTop: 1,
                            fontWeight: 700,
                            color: 'black',
                            fontFamily: 'Poppins',
                        }}
                        variant='body1'>
                        Save
                    </Typography>
                </Button>
            </div>
        </>
    );
};
